'use client';

import { useState, type ReactNode } from 'react';
import { MagazineTrackMetaContext, type MagazineTrackMetaProps } from './MagazineTrackMeta';

type MagazineTrackContainerProps = {
  children: ReactNode;
};

function MagazineTrackContainer({ children }: MagazineTrackContainerProps) {
  const [meta, setMeta] = useState<Partial<MagazineTrackMetaProps>>({});

  return (
    <MagazineTrackMetaContext.Provider value={setMeta}>
      <div
        className="ll-grid-container pt-5 pb-12"
        data-testid="magazine-track-container"
        {...(meta.container && { 'data-track-container': meta.container })}
        {...(meta.type && { 'data-track-type': meta.type })}
        {...(meta.title && { 'data-track-title': meta.title })}
        {...(meta.provider && { 'data-track-provider': meta.provider })}
      >
        {children}
      </div>
    </MagazineTrackMetaContext.Provider>
  );
}

export { MagazineTrackContainer, type MagazineTrackContainerProps };
